<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Work Items</md-icon>
                    </div>
                    <h4 class="title">Add Work Item</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="workItem.name"/>
                                    <validation-error :errors="apiValidationErrors.name"/>
                                </md-field>
                            </div>
                        </div>


                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Activity
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workItem.activity_id" name="activity_id">
                                        <md-option
                                                v-for="activity in available_activities_dropdown"
                                                :key="activity.id"
                                                :value="activity.id"
                                        >
                                            {{ activity.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Work Place
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workItem.workplace_id" name="workplace_id">
                                        <md-option
                                                v-for="workplace in available_workplaces_dropdown"
                                                :key="workplace.id"
                                                :value="workplace.id"
                                        >
                                            {{ workplace.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Date
                            </label>
                            <div class="md-layout-item">
                                <md-datepicker
                                        v-model="workItem.date"
                                        :md-model-type="String"
                                        :class="{ 'md-invalid': !!apiValidationErrors.date }"
                                >
                                    <label>Select date ...</label>
                                    <validation-error :errors="apiValidationErrors.date" />
                                </md-datepicker>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Guidance
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workItem.guidance_id" name="guidance_id">
                                        <md-option
                                                v-for="guidance in available_guidances_dropdown"
                                                :key="guidance.id"
                                                :value="guidance.id"
                                        >
                                            {{ guidance.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Activity Tariff
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="workItem.activity_tariff_id" name="activity_tariff_id">
                                        <md-option
                                                v-for="activity_tariff in available_activity_tariffs_dropdown"
                                                :key="activity_tariff.id"
                                                :value="activity_tariff.id"
                                        >
                                            {{ activity_tariff.amount }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Work Item</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({

        workItem: {
            type: 'workItems',
            name: null,
            activity_id: null,
            workplace_id: null,
            guidance_id: null,
            date: null,
            activity_tariff_id: null,
        },
        available_activities_dropdown: [],
        available_workplaces_dropdown: [],
        available_guidances_dropdown: [],
        available_activity_tariffs_dropdown: [],
    }),
    created () {
        this.getActivityDropDowns();
        this.getWorkplaceDropDowns();
        this.getGuidanceDropDowns();
        this.getActivityTariffDropDowns();
    },
    methods: {
        async add () {
            try {
                await this.$store.dispatch('workItems/add', this.workItem);
                this.notifySuccess('Work Item added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        getActivityDropDowns () {
            this.$store.dispatch('activities/list').then(() => {
                console.log(this.$store);
                this.available_activities_dropdown = this.$store.getters['activities/list'];
                if (this.available_activities_dropdown && this.available_activities_dropdown.length) {
                    this.workItem.activity_id = this.available_activities_dropdown[0].id;
                }
            });
        },
        getWorkplaceDropDowns () {
            this.$store.dispatch('workplaces/list').then(() => {
                this.available_workplaces_dropdown = this.$store.getters['workplaces/dropdown'];
                if (this.available_workplaces_dropdown && this.available_workplaces_dropdown.length) {
                    this.workItem.workplace_id = this.available_workplaces_dropdown[0].id;
                }
            });
        }, getGuidanceDropDowns () {
            this.$store.dispatch('guidances/list').then(() => {
                this.available_guidances_dropdown = this.$store.getters['guidances/dropdown'];
                if (this.available_guidances_dropdown && this.available_guidances_dropdown.length) {
                    this.workItem.guidance_id = this.available_guidances_dropdown[0].id;
                }
            });
        },
        getActivityTariffDropDowns () {
            this.$store.dispatch('activityTariffs/list').then(() => {
                console.log(this.$store);
                this.available_activity_tariffs_dropdown = this.$store.getters['activityTariffs/dropdown'];
                if (this.available_activity_tariffs_dropdown && this.available_activity_tariffs_dropdown.length) {
                    this.workItem.activity_tariff_id = this.available_activity_tariffs_dropdown[0].id;
                }
            });
        },
        goBack () {
            this.$router.push({ name: 'Work Items List' });
        },
    },
};
</script>
